import React, { useEffect, useRef, useState } from 'react'
// import { KTIcon } from '../../../_metronic/helpers';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
// import moment from "moment";
import '../../../common/rsuite-datepicker.css';
import Select, { components } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
// import Loader from '../../../common/Loader';
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, getValueFromResource } from '../../../common/timeLiveFunction';
import { selectedState, selectedSingleSelectState, setDateRangeState, updateProjectTaskState, updateAssignedProjectState, resetSelectedRecordObjectInState } from "./CustomReportViewSlice";
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';
import DatePickerRanges from '../../../common/DatePickerRanges';

export const CustomReportFilter = (props: any) => {
    const { AccountReportId, onHandleOnClickEvent } = props;
    const { selectedRecord, isLoading, filterList, isReload, filterDropDownList, ReportName, reportData } = useAppSelector((state) => state.customReportView);
    const properties = Object.keys(filterDropDownList);
    // const [numberOfFilters, setNumberOfFilters] = useState<number>(20);
    const dispatch = useAppDispatch();
    const singleSelectArray = ['Approved', 'Submitted', 'Billable', 'ActiveStatus', 'Disabled', 'BaseCurrency', 'ApprovalType', 'Reimbursement', 'Paid', 'Billed', 'TimesheetType', 'TimesheetPeriodType', 'TaskCompleted', "ddlReportType", "IncludeSubmittedDate"];
    const { maxMenuHeight, sessionAccountId, sessionAccountEmployeeId, showDisableProjectInReport, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat } = useAppSelector((state) => state.globalState);
    const { t } = useTranslation();
    const [displayedRange, setDisplayedRange] = useState(t('Please Select Date Range'));

    const handleDateRangeChange = (selectedDateRange: any, property: any) => {
        // dispatch(setDateRangeState({ property, dateRange: [moment(selectedDateRange[0]).format("YYYY-MM-DD"), moment(selectedDateRange[1]).format("YYYY-MM-DD")] }));
        if (selectedDateRange && selectedDateRange[0] && selectedDateRange[1]) {
            const formattedStartDate = format(selectedDateRange[0], CurrentCultureDateFormat.toString());
            const formattedEndDate = format(selectedDateRange[1], CurrentCultureDateFormat.toString());
            setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }
        // dispatch(setDateRangeState({ property, dateRange: [moment(selectedDateRange[0]).format(dateInsertionFormat), moment(selectedDateRange[1]).format(dateInsertionFormat)] }));
        // dispatch(setDateRangeState({ property, dateRange: [format(selectedDateRange[0], "yyyy-MM-dd"), format(selectedDateRange[1], "yyyy-MM-dd")] }));
        dispatch(setDateRangeState({ property, dateRange: [selectedDateRange[0], selectedDateRange[1]] }));
        //dispatch(setDateRangeState({ property, dateRange: [selectedDateRange[0].toISOString(), selectedDateRange[1].toISOString()] }));
    };

    const handleSingleSelectPropertyChange = (selectedOption: any, property: any) => {
        const { value, label } = selectedOption;
        dispatch(selectedSingleSelectState({ property, value }));
    };

    // const handlePropertyChange = (selectedOption: any, property: any) => {
    //     const values = selectedOption.map((option: any) => option.value);
    //     if (property === 'AssignedProject') {
    //         getAccountProjectTasksByAccountProjectId(values);
    //     }
    //     else if (property === 'Clients') {
    //         getAccountProjectsByClientId(values);
    //     }

    //     dispatch(selectedState({ property, values }));
    // };
    const handlePropertyChange = (selectedOption: any, property: any) => {
        if (!selectedOption || selectedOption.length === 0) {
            dispatch(selectedState({ property, values: [] }));
            return;
        }

        const isAllSelected = selectedOption.some((option: any) => option.value === "all");

        let values;
        if (isAllSelected) {
            values = filterDropDownList[property].map((item: any) => item.value);
        } else {
            values = selectedOption.map((option: any) => option.value);
        }

        if (property === 'AssignedProject') {
            getAccountProjectTasksByAccountProjectId(values);
        } else if (property === 'Clients') {
            getAccountProjectsByClientId(values);
        }

        dispatch(selectedState({ property, values }));
    };


    const getAccountProjectTasksByAccountProjectId = async (accountProjectId: any) => {
        if (accountProjectId.length > 0) {
            let accountProjectTaskId = "";
            let roles = "";
            let category = `${sessionAccountEmployeeId},${true},${accountProjectTaskId},${sessionAccountId},${AccountReportId},${roles}`;

            const response: any = await fetchAPI(
                `api/V2/Tasks/ProjectTasksForCustomizedReport/${accountProjectId}/${category}`,
                "GET",
                "",
                true
            );
            const json = await response.json();

            if (json.Data.length > 0) {
                const updatedTasks = json.Data.reduce((acc: any[], item: any) => {
                    const exists = acc.some(task => task.value === item.AccountProjectTaskId);
                    if (!exists) {
                        acc.push({
                            value: item.AccountProjectTaskId,
                            label: item.TaskName,
                            isSelected: 0
                        });
                    }
                    return acc;
                }, []);

                dispatch(updateProjectTaskState(updatedTasks));
            } else {
                dispatch(updateProjectTaskState([]));
            }
        } else {
            dispatch(updateProjectTaskState([]));
        }
    };



    // const getAccountProjectTasksByAccountProjectId1 = async (accountProjectId: any) => {
    //     if (accountProjectId.length > 0) {
    //         let accountProjectTaskId = "";
    //         let roles = "";
    //         let category = `${sessionAccountEmployeeId},${true},${accountProjectTaskId},${sessionAccountId},${AccountReportId},${roles}`;
    //         const response: any = await fetchAPI(`api/V2/Tasks/ProjectTasksForCustomizedReport/${accountProjectId}/${category}`, "GET", "", true);
    //         const json = await response.json();
    //         if (json.Data.length > 0) {
    //             json.Data.map((item: any) => {
    //                 item.value = item.AccountProjectTaskId;
    //                 item.label = item.TaskName;
    //                 delete item.AccountProjectTaskId;
    //                 delete item.TaskName;
    //             });
    //             dispatch(updateProjectTaskState(json.Data));
    //         } else {
    //             //dispatch(updateProjectTaskState([{ value: '', label: '' }]));
    //             dispatch(updateProjectTaskState([]));
    //         }
    //     } else {
    //         dispatch(updateProjectTaskState([]));
    //     }
    // }

    const getAccountProjectsByClientId = async (accountClientID: any) => {
        if (accountClientID.length > 0) {
            const response: any = await fetchAPI(`api/V2/Projects/AssignedProjectsByClientForCustomizedReport/${accountClientID}/${AccountReportId}`, "GET", "", true);
            const json = await response.json();
            if (json.Data.length > 0) {
                // if (showDisableProjectInReport) {
                //     json.Data.map((item: any) => {
                //         item.value = item.AccountProjectId;
                //          item.label = item.ProjectNameWithDisabled;
                //          delete item.AccountProjectId;
                //          delete item.ProjectNameWithDisabled;
                //          delete item.ProjectName;
                //      });
                    
                // }
                // else {
                //     json.Data.map((item: any) => {
                //         item.value = item.AccountProjectId;
                //         item.label = item.ProjectName;
                //         delete item.AccountProjectId;
                //         delete item.ProjectNameWithDisabled;
                //         delete item.ProjectName;
                //     });
                // }
                const updatedData = json.Data.map((item: any) => {
                item.isSelected = 0;

                if (showDisableProjectInReport) {
                    item.value = item.AccountProjectId;
                    item.label = item.ProjectNameWithDisabled;
                } else {
                    item.value = item.AccountProjectId;
                    item.label = item.ProjectName;
                }
                delete item.AccountProjectId;
                delete item.ProjectNameWithDisabled;
                delete item.ProjectName;

                return item;
            });
                dispatch(updateAssignedProjectState(json.Data));
            }
            else {
                dispatch(updateAssignedProjectState([]));
            }
        }
        else {
            dispatch(updateAssignedProjectState([]));
        }

    }
    const MultiValue = ({ index, getValue, ...props }: any) => {

        // const maxToShow = 0;

        // const overflow = getValue()
        //     .slice(maxToShow)
        //     .map((x: any) => x.label);

        // return index < maxToShow ? (
        //     <components.MultiValue {...props} />
        // ) : index === maxToShow ? (
        //     <>

        //         <MoreSelectedBadge items={overflow} totalItemCount={props.options.length} />
        //     </>
        // ) : null;
        const maxToShow = 0;
        const selectAllValue = "Select All";
        const selectedValues = getValue().filter((x: any) => x.value !== selectAllValue);
        const overflow = selectedValues.slice(maxToShow).map((x: any) => x.label);
        return index < maxToShow ? (
            <components.MultiValue {...props} />
        ) : index === maxToShow ? (
            <>
                <MoreSelectedBadge items={overflow} totalItemCount={props.options.length - 1} />
            </>
        ) : null;
    };

    const MoreSelectedBadge = ({ items, totalItemCount }: any) => {

        // const style = {
        //     background: "#d4eefa",
        //     borderRadius: "4px",
        //     fontSize: "12px",
        //     padding: "5px"
        // };

        // const title = items.join(", ");
        // const length = items.length;
        // const label = length === totalItemCount ? `All Selected(${length})` : ` ${length} Item${length !== 1 ? "s" : ""} Selected`;

        // return (
        //     <div style={style} title={title}>
        //         {label}
        //     </div>
        // );
        const style = {
            background: "#d4eefa",
            borderRadius: "4px",
            fontSize: "12px",
            padding: "5px"
        };

        const selectAllValue = "Select All";
        const selectedItemCount = items.filter((item: any) => item !== selectAllValue).length;

        const title = items.join(", ");
        const label = selectedItemCount === totalItemCount ? `All Selected(${selectedItemCount})` : ` ${selectedItemCount} Item${selectedItemCount !== 1 ? "s" : ""} Selected`;

        return (
            <div style={style} title={title}>
                {label}
            </div>
        );
    };

    const handleResetFiltersOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    };
    const allOption = { value: "all", label: "Select All" };
    const periodicReportId = filterList[0]?.SystemReportDataSourceId.toLowerCase() === '665306d7-d2d5-4a9b-a248-b7ad53d587e8';

    const customSelectStyles = {
        ...dropDownSelectionStyles,
        menu: (base: any) => ({ ...base, zIndex: 9999 }),
        menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    };

    return (
        <>
            {/* {isLoading && <Loader />} */}
            <div className='card-body'>
                <div className='row' >
                    {/* {properties.slice(0, numberOfFilters).map((property: any, index) => ( */}
                    {properties.map((property: any, index) => {
                        return(
                        <div className="col-md-4 mb-2" key={index} >
                            <label className="form-label fs-7 fw-normal">
                                {
                                    (property === 'ddlReportType' && periodicReportId) ? null : (property === 'ddlReportType') ?
                                        getValueFromResource('Report Type', dispatch, t)
                                        :
                                        getValueFromResource(`${filterList.find(item => item.SystemReportFilterSource === property)?.Caption.toString().split(":")?.[0]}`, dispatch, t)
                                    // filterList.find(item => item.SystemReportFilterSource === property)?.Caption

                                }
                            </label>
                            {(property === 'DateRange' || property === 'SubmittedDate') ?
                                <DateRangePicker
                                    onChange={(selectedDateRange) => handleDateRangeChange(selectedDateRange, property)}
                                    ranges={DatePickerRanges()}
                                    value={
                                        property === 'DateRange' ?
                                            [
                                                // filterDropDownList[property][0].StartDate === undefined || filterDropDownList[property][0].StartDate === null ? new Date() : new Date(filterDropDownList[property][0].StartDate),
                                                // filterDropDownList[property][0].EndDate === undefined || filterDropDownList[property][0].EndDate === null ? new Date() : new Date(filterDropDownList[property][0].EndDate)
                                                filterDropDownList[property][0].StartDate === undefined || filterDropDownList[property][0].StartDate === null ? new Date() : moment(filterDropDownList[property][0].StartDate).toDate(),
                                                filterDropDownList[property][0].EndDate === undefined || filterDropDownList[property][0].EndDate === null ? new Date() : moment(filterDropDownList[property][0].EndDate).toDate()
                                            ]
                                            :
                                            [
                                                // filterDropDownList[property][0].SubmittedStartDate === undefined || filterDropDownList[property][0].SubmittedStartDate === null ? new Date() : new Date(filterDropDownList[property][0].SubmittedStartDate),
                                                // filterDropDownList[property][0].SubmittedEndDate === undefined || filterDropDownList[property][0].SubmittedEndDate === null ? new Date() : new Date(filterDropDownList[property][0].SubmittedEndDate)
                                                filterDropDownList[property][0].SubmittedStartDate === undefined || filterDropDownList[property][0].SubmittedStartDate === null ? new Date() : moment(filterDropDownList[property][0].SubmittedStartDate).toDate(),
                                                filterDropDownList[property][0].SubmittedEndDate === undefined || filterDropDownList[property][0].SubmittedEndDate === null ? new Date() : moment(filterDropDownList[property][0].SubmittedEndDate).toDate()
                                            ]
                                    }
                                    cleanable={false}
                                    placement={((index + 1) % 3 === 0 || (index + 1) % 2 === 0 || (index + 1) % 2 === 1)&& property === 'SubmittedDate' ? "autoVerticalEnd" : "autoVerticalStart"}
                                    // placeholder={t('Please Select Date Range')}
                                    placeholder={displayedRange}
                                    character={' - '}
                                    className="basic-single fs-7 fw-normal"
                                    format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                                >
                                </DateRangePicker>
                                :

                                (singleSelectArray.includes(property) && !periodicReportId) ?
                                    <Select
                                        value={filterDropDownList[property]
                                            .filter((item: any) => item.isSelected === 1)
                                            .map((item: any) => ({ value: item.value, label: item.label }))}
                                        options={filterDropDownList[property].map((item: any) => ({
                                            value: item.value,
                                            label: item.label,
                                        }))}
                                        onChange={(selectedOptions) =>
                                            handleSingleSelectPropertyChange(selectedOptions, property)
                                        }
                                        // styles={dropDownSelectionStyles}
                                        styles={customSelectStyles}
                                        maxMenuHeight={maxMenuHeight}
                                        className="basic-single fs-7 fw-normal"

                                    />
                                    : (property === 'ddlReportType' && periodicReportId) ?
                                        null :
                                        // <Select
                                        //     value={
                                        //         filterDropDownList[property]
                                        //             .filter((item: any) => item.isSelected === 1)
                                        //             .map((item: any) => ({ value: item.value, label: item.label }))
                                        //     }
                                        //     closeMenuOnSelect={false}
                                        //     options={filterDropDownList[property].map((item: any) => ({
                                        //         value: item.value,
                                        //         label: item.label,
                                        //     }))}
                                        //     isMulti
                                        //     onChange={(selectedOptions) =>
                                        //         handlePropertyChange(selectedOptions, property)
                                        //     }
                                        //     components={{ MultiValue }}
                                        //     hideSelectedOptions={false}
                                        //     styles={dropDownSelectionStyles}
                                        //     maxMenuHeight={maxMenuHeight}
                                        //     className="basic-single fs-7 fw-normal"
                                        // />
                                        <Select
                                            value={
                                                filterDropDownList[property].some((item: any) => item.isSelected === 1)
                                                    ? filterDropDownList[property]
                                                        .filter((item: any) => item.isSelected === 1)
                                                        .map((item: any) => ({ value: item.value, label: item.label }))
                                                    : []
                                            }
                                            placeholder="None Selected"
                                            closeMenuOnSelect={false}
                                            options={[
                                                allOption,
                                                ...filterDropDownList[property].map((item: any) => ({
                                                    value: item.value,
                                                    label: item.label,
                                                })),
                                            ]}
                                            isMulti
                                            onChange={(selectedOptions) => {
                                                if (!selectedOptions || selectedOptions.length === 0) {
                                                    handlePropertyChange([], property); // No selection
                                                    return;
                                                }

                                                // Check if "Select All" is chosen
                                                const isAllSelected = selectedOptions.some((option: any) => option.value === "all");

                                                if (isAllSelected) {
                                                    handlePropertyChange(filterDropDownList[property], property); // Select all items
                                                } else {
                                                    handlePropertyChange(selectedOptions, property); // Normal selection
                                                }
                                            }}
                                            components={{ MultiValue }}
                                            hideSelectedOptions={false}
                                            // styles={dropDownSelectionStyles}
                                            styles={customSelectStyles}
                                            maxMenuHeight={maxMenuHeight}
                                            className="basic-single fs-7 fw-normal"
                                        />
                            }
                        </div>
                    )})}
                </div>

            </div>
            <div className='card-footer pt-4 '>
                <div className='d-flex flex-stack float-end'>
                    <div className='d-flex align-items-center me-2'>
                        <button
                            type='button'
                            //ref={closeButtonRef}
                            style={{ display: 'none' }}
                            id='kt_OffCanvas_close'
                        >
                            {/* {t('Apply Filter')} */}
                            {getValueFromResource('Apply Filter', dispatch, t)}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm me-2 fs-7"
                            data-kt-element='send'
                            id='kt_OffCanvas_close'
                            onClick={handleResetFiltersOnClickEvent}
                        >
                            {/* {t('Reset Filters')} */}
                            {getValueFromResource('Reset Filters', dispatch, t)}
                        </button>
                        <button
                            id="kt_OffCanvas"
                            type="button"
                            //data-kt-element='send'
                            className="btn btn-primary btn-sm fs-7 "
                            onClick={onHandleOnClickEvent}
                        >
                            {/* {t('Apply Filters')} */}
                            {getValueFromResource('Apply Filters', dispatch, t)}
                        </button>
                    </div>
                </div>
            </div>
        </>

    )

}